import {getMainCanvasDOMElement} from './mainCanvasDOM';
import {requestResizeWindow} from './moduleCaller';

/**
 * @remarks
 * ウィンドウクライアントサイズをcanvasに反映させる
 */
export const hel_reflectCanvasSize = () => {
  if (!globalThis.g_ReflectCanvasSizeMode) return;

  const mainCanvas = getMainCanvasDOMElement();
  if (mainCanvas === undefined) return;

  const width = Math.floor(mainCanvas.clientWidth * window.devicePixelRatio);
  const height = Math.floor(mainCanvas.clientHeight * window.devicePixelRatio);

  if (width <= 0 || height <= 0) {
    return;
  }

  mainCanvas.width = width;
  mainCanvas.height = height;
};

/**
 * @remarks
 * JSからC++に画面サイズの変更をリクエスト
 */
export const hel_resizeWindow = () => {
  hel_reflectCanvasSize();

  const mainCanvas = getMainCanvasDOMElement();
  if (mainCanvas !== undefined) {
    requestResizeWindow(mainCanvas);
  }
};
